import { render, staticRenderFns } from "./PasswordRecover.vue?vue&type=template&id=21f10504&scoped=true&"
import script from "./PasswordRecover.vue?vue&type=script&lang=js&"
export * from "./PasswordRecover.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecover.vue?vue&type=style&index=0&id=21f10504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f10504",
  null
  
)

component.options.__file = "PasswordRecover.vue"
export default component.exports